// NotFound.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Unauthorized = () => {
  const { t } = useTranslation();

  return (
    <div className="container mt-5 text-center">
      <h1>{t('Unauthorized')}</h1>
      <p>{t('Access to this resource is denied.')}</p>
      <Link to="/" className="btn btn-primary">{t('Go to Home')}</Link>
    </div>
  );
};

export default Unauthorized;
